import axios, { AxiosResponse } from "axios";

export const importFiling = async (
  file: File,
  country: string,
  taxonomy: string,
  reportDate: string,
  abortSignal: AbortSignal | undefined
): Promise<AxiosResponse<void>> => {
  const formData = new FormData();
  formData.append("reportPackage", file);
  return axios.post(
    `/api/filings/import/?country=${country}&taxonomy=${taxonomy}&reportDate=${reportDate}`,
    formData,
    {
      signal: abortSignal,
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
};